// extracted by mini-css-extract-plugin
export default {"CVChartContainer":"CVCharts_CVChartContainer__5G7cn"};